import styled from '@emotion/styled';


export const SectionWrapper = styled.div`
    background: rgb(238,238,238);
    background: linear-gradient(90deg, rgba(238,238,238,0.9781162464985994) 0%, rgba(238,238,238,0.8884803921568627) 24%, rgba(233,232,230,1) 45%, rgba(214,207,199,1) 100%);
    z-index: -100;
`;